import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '../../../axios/axiosInstance';

export const useGetGoogleAuthUrl = () =>
  useMutation(async () => {
    const { data } = await axiosInstance.get('/api/auth/member/google-auth-url');
    return data;
  });
